import { axiosInstance } from '@/api'
export default class RequestTemaplatesApi {
  /**
   * @param {String} templateId
   */
  async getById (templateId, isGlobal) {
    // console.log(`id`, templateId)
    const result = {}
    try {
      const response = await axiosInstance.get(
        `/request-templates/${templateId}`,
        {
          params: {
            isGlobal
          }
        }
      )
      // console.log(`result`, result)
      result.result = response.data
      result.error = null
    } catch (error) {
      result.result = null
      result.error = error.response
    }
    return result
  }
}
